import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useMemo } from "react";

import { TopPage } from "@/modules/irohana-components/elements/TopPage";
import { Tab } from "@/modules/irohana-components/elements/Tab";
import { ORGANIZATION_TABS } from "@/features/organization/constants/tabs";
import { SHARED_COMPONENT_TAB_HEIGHT } from "@/constants/common";
import { OrganizationContainer } from "@/features/organization/components/OrganizationContainer";

/** Returns the active tab value for the current pathname (edit paths still map to their tab). */
const getActiveTabValue = (pathname: string): string => {
  const matched = ORGANIZATION_TABS.find((tab) => pathname === tab.path || pathname.startsWith(`${tab.path}/`));
  return matched?.value ?? ORGANIZATION_TABS[0].value;
};

export const OrganizationLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const activeTab = useMemo(() => getActiveTabValue(location.pathname), [location.pathname]);

  const options = useMemo(() => ORGANIZATION_TABS.map((tab) => ({ label: tab.label, value: tab.value })), []);

  const handleChangeTab = (_event: React.SyntheticEvent, value: string | number) => {
    const tab = ORGANIZATION_TABS.find((item) => item.value === value);
    if (tab && tab.path !== location.pathname) {
      navigate(tab.path);
    }
  };

  return (
    <OrganizationContainer>
      <TopPage title="組織設定" enablePageBack={false} />

      {/* Tab bar only — the page content (and its footer) render outside the tab's white
          panel so cards and the sticky footer sit on the page background, not inside a box. */}
      <Tab value={activeTab} selected={activeTab} options={options} onChange={handleChangeTab} tabHeight={SHARED_COMPONENT_TAB_HEIGHT} />

      <Outlet />
    </OrganizationContainer>
  );
};
